import { ReactNode, useMemo, useState } from "react";
import { VendedoresList } from "../../VendedorList/components/VendedorList";
import { CreateVendedorForm } from "../../CreateVendedor/components/CreateVendedorForm";
import { VendedorDetails } from "../../VendedorDetails/components/VendedorDetails";
import { useAdminPanelUI } from "../../../../hooks/useAdminPanelUI";

export function VendedoresContainer() {
    const { vendedorActions } = useAdminPanelUI();
    const [vendedorSelectedId, setVendedorSelectedId] = useState<number>(0);

    const actions: Record<string, ReactNode> = useMemo(() => ({
        "VendedoresList": <VendedoresList
                        setVendedorSelected={setVendedorSelectedId} />,
        "CreateVendedorForm": <CreateVendedorForm
                                setVendedorSelected={setVendedorSelectedId} />,
        "VendedorDetails": <VendedorDetails
                                vendedorId={vendedorSelectedId} />
    }), [vendedorSelectedId]);

    const currentAction = actions[vendedorActions];

    return (
        <div className="h-full w-full">
            {currentAction}
        </div>
    );
}
